

import {changePassword} from '@/api/user'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XInput,
Group,
XButton

},
data () {
return {
passwordModel: {
password: '',
password_confirmation: '',
password_old: ''
}
}
},
methods: {
handleChangePwd () {
changePassword(this.passwordModel).then(resp => {
this.$vux.toast.show({
text: '密码修改成功',
type: 'success',
time: 3000,
onHide () {
this.$router.go(-1)
}
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/changePwd/index.vue